import React from "react";
import { NavBar, Footer } from "../../components";
import "./struktur.scss";

// Import foto BPMJ dari assets (sesuai yang sudah kamu export)
import {
    KetuaBPImg,
    WakaBPImg,
    SekBP,
    BendBP,
    BP_Vera,
    BP_Rine,
    BP_Junus,
    Pdt_Pelsus
} from "../../assets";

// ============ DATA BPMJ (Foto sudah dimasukkan langsung) ============
const dataBPMJ = [
    {
        title: "Ketua",
        name: "Pdt. Ria Dorothea Luntungan, S.Th",
        photo: KetuaBPImg,
        positionClass: "top-level",
    },
    {
        title: "Wakil Ketua",
        name: "Pnt. Reymoond Hendra Mudami, S.Pi",
        photo: WakaBPImg,
        positionClass: "top-level",
    },
    {
        title: "Sekretaris",
        name: "Pnt. Asnou Yahnel Larope, S.E",
        photo: SekBP,
        positionClass: "top-level",
    },
    {
        title: "Bendahara",
        name: "Dkn. Alberki Hengkeng",
        photo: BendBP,
        positionClass: "top-level",
    },
    {
        title: "Anggota BPMJ",
        name: "Pnt. Junus Abdul Karel",
        photo: BP_Junus,
        positionClass: "bottom-level",
    },
    {
        title: "Anggota BPMJ",
        name: "Pnt. Inriane Peloan, S.Pd",
        photo: BP_Rine,
        positionClass: "bottom-level",
    },
    {
        title: "Anggota BPMJ",
        name: "Pnt. Verawati Tinungki",
        photo: BP_Vera,
        positionClass: "bottom-level",
    },
];

const StrukturOrganisasi = () => {
    const topRow = dataBPMJ.slice(0, 4);
    const bottomRow = dataBPMJ.slice(4);

    const renderBPMJMember = (member, index) => (
        <div key={index} className="member-card">
            <div className="member-circle">
                {member.photo ? (
                    <img
                        src={member.photo}
                        alt={member.name}
                        className="member-photo"
                    />
                ) : (
                    <div className="no-photo">No Image</div>
                )}
            </div>

            <p className="member-title">{member.title}</p>
            <p className="member-name">{member.name}</p>
        </div>
    );

    return (
        <div className="struktur-organisasi-page">
            <NavBar />

            <main className="content-container">
                {/* BPMJ */}
                <section className="bpmj-section">
                    <h2 className="section-title bpmj-title">
                        Badan Pekerja Majelis Jemaat GMIM Genesaret Pateten
                    </h2>
                    <h2 className="service-period">Periode Pelayanan 2022 - 2026</h2>

                    <div className="bpmj-grid">
                        <div className="bpmj-row top-row">{topRow.map(renderBPMJMember)}</div>
                        <div className="bpmj-row bottom-row">{bottomRow.map(renderBPMJMember)}</div>
                    </div>
                </section>

                <hr className="divider" />

                {/* PELAYAN KHUSUS */}
                <section className="pendeta-section">
                    <h2 className="section-title pendeta-title">
                        Pendeta - Pendeta &amp; Pelayan Khusus Jemaat GMIM Genesaret Pateten
                    </h2>
                    <p className="service-period">Periode Pelayanan 2022 - 2026</p>
                       <img src={Pdt_Pelsus}/>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default StrukturOrganisasi;
